import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeedNotificationResponse } from 'app/interfaces/feed-notifications.interface';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class FeedNotificationService {
	url = `${environment.servicesUrl}/notifications/v2/`;

	constructor(private http: HttpClient) {}

	getUnseenNotifications(): Observable<{ total: number }> {
		return this.http.get<{ total: number }>(
			`${this.url}feed/unseen?target=PROFESSIONAL`
		);
	}

	getFeedNotifications(
		skip: number,
		limit: number
	): Observable<FeedNotificationResponse> {
		return this.http.get<FeedNotificationResponse>(
			`${this.url}feed?skip=${skip}&limit=${limit}&target=PROFESSIONAL`
		);
	}

	setNotificationsAsSeen(ids: number[]): Observable<{ success: boolean }> {
		return this.http.post<{ success: boolean }>(`${this.url}feed/seen`, {
			ids,
		});
	}

	setNotificationAsInteracted(id: number): Observable<{ success: boolean }> {
		return this.http.post<{ success: boolean }>(`${this.url}feed/interacted`, {
			ids: [id],
		});
	}

	setNotificationAsHidden(id: number): Observable<{ success: boolean }> {
		return this.http.post<{ success: boolean }>(`${this.url}feed/hidden`, {
			ids: [id],
		});
	}
}
